module.exports = __webpack_public_path__ + "img/awards_image_11.53290b10.jpg";